"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _DOMSelectors = require("../constants/DOMSelectors");

var ResendVerificationEmailButton = function ResendVerificationEmailButton() {
  return "\n  <a class=\"fire-alarm_alarm-status-page-link uiLinkWithUnderline\" id=\"" + _DOMSelectors.RESEND_VERIFICATION_EMAIL_BUTTON_ID + "\" style=\"cursor: pointer;\">\n    " + _I18n.default.text('emailConfirmBar.resendButton') + "\n  </a>\n";
};

var _default = ResendVerificationEmailButton;
exports.default = _default;
module.exports = exports.default;